/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SuspendedInfoContainer_viewer = {
    readonly status: {
        readonly suspension: {
            readonly until: string | null;
        };
    };
    readonly " $refType": "SuspendedInfoContainer_viewer";
};
export type SuspendedInfoContainer_viewer$data = SuspendedInfoContainer_viewer;
export type SuspendedInfoContainer_viewer$key = {
    readonly " $data"?: SuspendedInfoContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SuspendedInfoContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuspendedInfoContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "UserStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "SuspensionStatus",
                    "kind": "LinkedField",
                    "name": "suspension",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "until",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'd1330697084b0a323c0c2dea0c5b2128';
export default node;
